<template>
    <b-container v-if="load.Loading" class="container-basic-spinner"> 
        <spinner />
    </b-container>
    <b-container v-else>

        <b-row class="m-0">

            <b-col>
                <a @click="entity.toogleShowAll()"
                   class="is-show-text"
                   href="#">
                {{textIsShowAll}}</a>
            </b-col>

            <transition name="visibility-switch">
                <b-col v-if="entity.IsUpdateSorting" class="h-end">
                    <b-button id="admin-btn-save" 
                              class="admin-button mr-10"
                              @click="updateSorting" >
                        Сохранить
                    </b-button>
                    <b-button id="admin-btn-cancel" 
                              class="admin-button m-0"
                              @click="cancelUpdate">
                        Отменить
                    </b-button>
                </b-col>
            </transition>

        </b-row>

        <branch-list v-model="entity.Branches" 
                     @update="entity.setIsUpdateSorting()" />

    </b-container>
</template>

<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import BranchesModel from '@/store/models/admin/branches/Branches'

import BranchList from '@/components/admin/branches/BranchList'

export default {
    computed: {
        textIsShowAll: function() {
            return this.entity.IsShowAll
                                ? 'Свернуть все'
                                : 'Развернуть все';                                            
        },
    },
    data: function() {
        let load = new Loading();
        
        this.getAll(load);

        return {
            load: load,
            entity: [],
            entityClone: []
        }
    },
    methods: {
        getAll: function(load) {
            load.Calculate(true);

            apiService.Admin.Branches.GetAll()
                .then(response => {
                    this.entity = new BranchesModel().mapFromDto(response.data);
                    this.entityClone = JSON.parse(JSON.stringify(new BranchesModel().mapFromDto(response.data)));
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        cancelUpdate: function() {
            this.entity = new BranchesModel().mapFromDto(this.entityClone.Branches);
        },
        updateSorting: function() {
            this.load.Calculate(true);

            let branchesDto = this.entity.mapToDto();

            apiService.Admin.Branches.PostUpdateSorting(branchesDto)
                .then(response => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(error => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        BranchList
    }
}
</script>